import isEmpty from 'lodash/isEmpty';
import values from 'lodash/values';
import { IRequestStatus } from '../../declarations';

export const getListing = state => {
  const listing = state.getIn(['agentResaleOfferPortal', 'listing']);
  return isEmpty(listing) ? {} : listing.toJS();
};
export const setListingOffer = state => {
  const listingOffer = state.getIn(['agentResaleOfferPortal', 'listingOffer']);
  return isEmpty(listingOffer) ? {} : listingOffer.toJS();
};

export const getAgent = state => {
  const agent = state.getIn(['agentResaleOfferPortal', 'agent']);
  return isEmpty(agent) ? {} : agent.toJS();
};

export const getTypedAgentEmail = state => {
  return state.getIn(['agentResaleOfferPortal', 'typedAgentEmail']);
};

export const getTypedAgentFullName = state => {
  const typedAgentFullName = state.getIn(['agentResaleOfferPortal', 'typedAgentFullName']);

  return isEmpty(typedAgentFullName) ? '' : typedAgentFullName;
};

export const getTypedAgentPhoneNumber = state => {
  const typedAgentPhoneNumber = state.getIn(['agentResaleOfferPortal', 'typedAgentPhoneNumber']);

  return isEmpty(typedAgentPhoneNumber) ? '' : typedAgentPhoneNumber;
};

export const getIsLoadingAgent = state => {
  return state.getIn(['agentResaleOfferPortal', 'isLoadingAgent']);
};

export const getIsLoadingListing = state => {
  return state.getIn(['agentResaleOfferPortal', 'isLoadingListing']);
};

export const getOfferSubmissionCompleted = state => {
  return state.getIn(['agentResaleOfferPortal', 'offerSubmissionCompleted']);
};

export const getOfferDetails = state => {
  return state.getIn(['agentResaleOfferPortal', 'offerDetails']);
};

export const agentAndListingData = state => {
  const portalState = state.getIn(['agentResaleOfferPortal']).toJS();

  return {
    contact_name: portalState.typedAgentFullName,
    contact_phone: portalState.typedAgentPhoneNumber,
    listing_slug: portalState.listing.slug,
  };
};

export const getErrors = state => {
  const { agentError, documentsWithUploadErrors, listingError, listingOfferError } = state
    .getIn(['agentResaleOfferPortal'])
    .toJS();

  return {
    agentError,
    documentsWithUploadErrors: new Set(documentsWithUploadErrors),
    listingError,
    listingOfferError,
  };
};

export const getDocumentUploadFailures = state =>
  state.getIn(['agentResaleOfferPortal', 'failedUploadS3Keys']);

export const getPendingDocumentUploads = state => {
  const requestMap = state.getIn(['agentResaleOfferPortal', 'uploadOfferDocumentsRequests']).toJS();

  if (isEmpty(requestMap)) {
    return false;
  }
  return !values(requestMap).every((status: IRequestStatus) => !status.isLoading);
};
